// extracted by mini-css-extract-plugin
module.exports = {"title":"footerMenuList_title__3xeH6","item":"footerMenuList_item__3jkwT","link":"footerMenuList_link__2L6-_","focus":"footerMenuList_focus__1wWuH"};